var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYaakIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.574 5.733c.58 0 1.097-.361 1.294-.903L18.939 2h2.667l-1.386 3.692a3.89 3.89 0 0 1-3.645 2.53h-9.63a3.773 3.773 0 0 1-3.519-2.429L2 2h2.673l1.098 2.923c.183.487.65.81 1.174.81h9.629Zm-4.747 3.625c-3.436 0-6.222 2.83-6.222 6.321C5.605 19.17 8.39 22 11.827 22c3.437 0 6.222-2.83 6.222-6.321a6.372 6.372 0 0 0-1.822-4.47 6.173 6.173 0 0 0-4.4-1.851Zm0 10.114c-2.062 0-3.733-1.698-3.733-3.793s1.671-3.793 3.733-3.793c2.062 0 3.733 1.698 3.733 3.793 0 1.006-.393 1.97-1.093 2.682-.7.711-1.65 1.11-2.64 1.11Z",
  fill: "#5960DE"
})));
export { SvgYaakIcon as ReactComponent };
export default __webpack_public_path__ + "010949bd1e337f90b15553349cac9fd0.svg";